// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { HireCreditLimit } = require('components/hire/hireCreditLimit/hireCreditLimit');
const { HirePaymentMethod } = require('components/hire/hirePaymentMethod/hirePaymentMethod');
import { DisclaimerPersonalInfo } from 'components/hire/cardViaT/disclaimerPersonalInfo/disclaimerPersonalInfo';

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');

// @ constants
const {
    THIRD_STEP,
    WIZARD_THIRD_STEP
} = require('constants/index');
const {
    CREDIT_CARD_REVOLVING_PROCESS,
} = require('constants/flagBasedFeatures');

class HireCardDiamondPackStep3 extends React.Component {
    constructor(props) {
        super(props);
        this.onCreditLimitModalContinue = this.onCreditLimitModalContinue.bind(this);
    }

    componentDidMount() {
        const {
            accountsIndexes,
            immAccounts,
            setAllAccountsToInactive
        } = this.props;
        const allAccountsInactive = hasAllAccountsInactive(accountsIndexes, immAccounts.get('byId'));
        if(allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }


    onCreditLimitModalContinue() {
        const {
            immHireCreditLimit,
            setHireCreditLimit,
            toggleCreditLimitModal,
            validate,
        } = this.props;

        setHireCreditLimit(immHireCreditLimit.get('creditLimitModalValue'), true);
        toggleCreditLimitModal(false);
        validate(WIZARD_THIRD_STEP, true);
    }

    render() {
        const {
            accountsIndexes,
            handleAccountChange,
            immAccounts,
            immFlagBasedFeatures,
            immGlobalVariables,
            immHireCardDiamondPack,
            immHireCardImageSelector,
            immHireCreditLimit,
            immHirePaymentMethod,
            isInactiveAccountsEnabled,
        } = this.props;
        const immStep3 = immHireCardDiamondPack.getIn(['steps', THIRD_STEP]);
        const accountErrorMsgVisible = immStep3.get('accountIsDirty') && !immStep3.get('accountIsValid');
        const accountErrorMsg = formatText('hireCardDiamondPack-step3SelectAccountError');
        const accountLabel = formatText('hireCardDiamondPack-step3SelectAccount');
        const disclaimerPersonalInfoUrl = formatText('disclaimerPersonalInfo-diamondPackLinkUrl');
        const selectedImageId = immHireCardImageSelector.get('selectedImageId');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        const messageVisible = !immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);

        return (
            <article className="hire-card-diamond-pack-step-three">
                <FormattedText
                    className="hire-card-diamond-pack__step-title"
                    value="hireCardDiamondPack-step3Title"
                />
                <DropdownAccounts
                    accountsIndexes={accountsIndexes}
                    blockedAccountsAll={immAccounts.get('blockedAccountsAll')}
                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                    currentAccountId={immStep3.get('accountId')}
                    error={accountErrorMsgVisible}
                    errorMsg={accountErrorMsg}
                    immAccounts={immAccounts.get('byId')}
                    label={accountLabel}
                    onAccountChange={handleAccountChange}
                    showAvailableBalance={true}
                    optionalElement={DisclaimerPersonalInfo()}
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    loading={isBlockedAccountsLoading}
                />
                <h4 className="hire-card-diamond-pack__section-header">
                    <FormattedText value="hireCardDiamondPack-step3CardData" />
                </h4>
                <HireCreditLimit
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    productSubType="002"
                    productType="501"
                    referenceStandard={`0000${selectedImageId.substring(10)}`}
                    handleModalContinue={this.onCreditLimitModalContinue}
                />
                <HirePaymentMethod
                    creditType="diamond"
                    immCreditLimit={immHireCreditLimit}
                    immGlobalVariables={immGlobalVariables}
                    immHirePaymentMethod={immHirePaymentMethod}
                />
                <OKMessage
                    type="informative"
                    visible={messageVisible}
                >
                    <FormattedText value="disclaimerPersonalInfo-diamondPackMsg" />
                    &nbsp;
                    <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                        <FormattedText value="disclaimerPersonalInfo-diamondPackLinkText" />
                    </OKLink>
                </OKMessage>
            </article>
        );
    }
}

HireCardDiamondPackStep3.propTypes = {
    accountsIndexes: PropTypes.array,
    handleAccountChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardDiamondPack: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    setHireCreditLimit: PropTypes.func.isRequired,
    toggleCreditLimitModal: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
};

module.exports = HireCardDiamondPackStep3;
